import React, { useEffect } from 'react'
import Navbar from './Navbar'
import Testimonials from './Testimonials'
import Footer from './Footer'
import BannerImg from '../Images/bannerImage.png'
import Ic1 from '../Images/ic1.png'
import Ic2 from '../Images/ic2.png'
import Ic3 from '../Images/ic3.png'
import Ic4 from '../Images/ic4.png'
import WorkI1 from '../Images/workI1.png'
import WorkI2 from '../Images/work2.png'
import WorkI3 from '../Images/work3.png'
import { FaAngleRight,FaCircleXmark,FaCircleCheck } from "react-icons/fa6";
import FadeInSection from "./FadeInSection";
import './MediaQ.css'

const Home = () => {
 
    const buildBtnFunc=()=>{
        window.open(
        "https://calendar.google.com/appointments/schedules/AcZssZ38A2sb_A746LeVdgb2ZQHuT9pp1V4wzouMVcRY2-p65ASHcvz0t25i5m3YK5uWu5Fkz4v6qy3t",
        "_blank"   // opens in new tab/window
    );
    }
  return (
    <>
    <Navbar/>
    {/* --------------------------banner----------------------- */}
    
    <div className='banner-section container'>
        <div className='row d-flex align-items-center justify-content-center'>
            <div className='col-sm-7'>
                <div className='bannerP1'>Skip the noise. Forget the hype.</div>
                <div className='bannerH3'>
                Grow Your Wealth<br/>with a Proven,<br/>Planner-Built Portfolio
                </div>
                <p className='bannerP2'>
                Get a personalised Mutual Fund Growth Plan built by real<br/>
                planners — not bots, not influencers, not product sellers.
                </p>
                <div className='Btn'>
                <button onClick={buildBtnFunc}>Build My Growth Plan <FaAngleRight style={{ marginTop:'4px' }} /></button>
                </div>
            </div>
            <div className='col-sm-5'>
                <div className='bannerImg'>
                <img alt="" src={BannerImg} />
                </div>
            </div>
        </div>
    </div>
 {/* --------------------------sec2----------------------- */}
 <FadeInSection>
    <div className='sec2'>
        <h1>Real <span>Planners.</span></h1>
    </div>
    <div className='row sec2Card' align='center'>
        <div className='col-md-2'></div>
        <div className='col-md-4'>
            <div className='custom-card'>
              <h5>What we Don’t Do</h5>
                <p><span><FaCircleXmark /></span>Confusing apps</p>
                <p><span><FaCircleXmark /></span>Commission pushers</p>
                <p><span><FaCircleXmark /></span>Market noise</p>
                <p><span><FaCircleXmark /></span>Fancy dashboards</p>
            </div>
        </div>
         <div className='col-md-4'>
                <div className='custom-card2'>
              <h5>What we Do</h5>
                <p><span><FaCircleCheck /></span>Clear, actionable plans</p>
                <p><span><FaCircleCheck /></span>Certified planners who work</p>
                <p><span><FaCircleCheck /></span>Evidence-based investing</p>
                <p><span><FaCircleCheck /></span>Transparent tracking & honest updates</p>
            </div>
         </div>
        <div className='col-md-2'></div>
    </div>
    </FadeInSection>
    <FadeInSection>
     <div className='sec3'>
        <p>We Don’t Sell Products</p>
        <h2>We build portfolios designed for <br/>your goals and your timeline.</h2>
        <br/>
        <div className='Btn'align="center">
            <button onClick={buildBtnFunc}>Build My Growth Plan <FaAngleRight style={{ marginTop:'4px' }} /></button>
        </div>
    </div>
    </FadeInSection>
     <FadeInSection>
    <div className='sec4 container'>
        <h2 className='borderHead'>What you Get</h2>
        <div className='row'>
            <div className='col-md-6'>
                <div className="cardShadow">
                    <div className='row'>
                    <div className='col-lg-2'>
                        <img src={Ic1} alt=""/>
                    </div>
                    <div className='col-lg-10'>
                        <h4>Goal-Based Planning</h4>
                        <p>A goal-based investment plan tailored to your income, age, and priorities</p>
                    </div>
                    </div>
                </div>
            </div>
            <div className='col-md-6'>
            <div className="cardShadow">
                    <div className='row'>
                    <div className='col-lg-2'>
                        <img src={Ic2} alt=""/>
                    </div>
                    <div className='col-lg-10'>
                        <h4>Research-Backed Portfolios</h4>
                        <p>Access to mutual-fund portfolios backed by research & consistent performance</p>
                    </div>
                    </div>
                </div>
            </div>
             <div className='col-md-6'>
               <div className="cardShadow">
                    <div className='row'>
                    <div className='col-lg-2'>
                        <img src={Ic3} alt=""/>
                    </div>
                    <div className='col-lg-10'>
                        <h4>Active Management</h4>
                        <p>Regular reviews & rebalancing to keep your money working hard</p>
                    </div>
                    </div>
                </div>
            </div>
            <div className='col-md-6'>
              <div className="cardShadow">
                    <div className='row'>
                    <div className='col-lg-2'>
                        <img src={Ic4} alt=""/>
                    </div>
                    <div className='col-lg-10'>
                        <h4>Human Touch</h4>
                        <p>A human planner to talk to — not an algorithm</p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <br/>
           <div className='Btn'align="center">
            <button onClick={buildBtnFunc}>Build My Growth Plan <FaAngleRight style={{ marginTop:'4px' }} /></button>
        </div>
    </div>
    </FadeInSection>

    <FadeInSection>
    <div className='Gapp'></div>
    <div align="center">
        <h2 className='borderHead'>How It Works</h2>
    <div className='row container workSection'>
        <div className='col-sm-3'>
            <div className='sqBox'>
                <img src={WorkI1} alt="" className='workI'/>
            </div>
            <b>Book a Free Call</b>
            <p>Share your goals & <br/>current investments</p>
        </div>
         <div className='col-sm-6'>
            <div className="boxWrapper">
                <div className="sideLine"></div>
                <div className='sqBox'>
                 <img src={WorkI2} alt="" className='workI'/>
                </div>
                <div className="sideLine"></div>
            </div>
               <b>Get Your Personalised Plan</b>
                <p>See how to optimise & grow</p>
        </div>
         <div className='col-sm-3'>
             <div className='sqBox'>
            <img src={WorkI3} alt="" className='workI'/>
            </div>
            <b>Invest & Track</b>
            <p>Sit back while we manage,<br/> monitor & update</p>
        </div>
    </div>
</div>

  <div className='Gapp'></div>
<div className='container'>
    <div className='row jargon'>
        <div className='col-md-8'>
            <p>No jargon. No spam</p>
            <h5>Just results</h5>
        </div>
         <div className='col-md-4'>
             <div className='Btn'align="right">
            <button onClick={buildBtnFunc}>Build My Growth Plan <FaAngleRight style={{ marginTop:'4px' }} /></button>
         </div>
        </div>
    </div>
    </div>
    </FadeInSection>

    <FadeInSection>
    <div className='Gapp'></div>
      <div className='investorSec'>
         <h2 className='borderHeadWhite'>What Investors Say</h2>
           {/* ------------------------testimonials------------------- */}
            <Testimonials/>
         {/* -------------------------------testimonial ends---------- */}
            <div className='Gapp'></div>
            <div className='Btn'align="center">
            <button onClick={buildBtnFunc}>Build My Growth Plan <FaAngleRight style={{ marginTop:'4px' }}/></button>
            </div>
    </div>
    </FadeInSection>
   
       <div className='growSec'>
         <FadeInSection>
            <h2 className='borderHeadWhite'> India Is Growing.<br/>Own a Piece of Its Future.</h2>
            <p className='sec5Text'>India’s economy is expanding faster than any major market in the world.<br/>
                When businesses grow, investors grow — if they participate. But most people<br/>
                only work in India’s growth story. They don’t invest in it.<br/><br/>
                Equity is the bridge between your effort and the nation’s progress.<br/>
                We’ll help you cross it, steadily, confidently.<br/><br/>
            </p>
            <h3>smartly. steadily. confidently.</h3>
            <div className='Gapp'></div>
            <div className='Btn'align="center">
            <button onClick={buildBtnFunc}>Build My Growth Plan <FaAngleRight style={{ marginTop:'4px' }}/></button>
            </div>
            <div className='Gapp'></div>
             </FadeInSection>
       </div>
      
    <Footer/>
    </>
  )
}

export default Home